<template>
  <b-card>
    <b-row>
      <!-- <b-col sm="4" class="pb-1">
        <b-button
          class="w-100"
          variant="outline-primary"
          :to="{ name: 'organization-location-add' }"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
          />
          {{ $t('message.Add_Location') }}
        </b-button>
      </b-col> -->
      <b-col sm="4">
        <b-form-group>
          <b-form-input
            v-model="searchQuery"
            type="search"
            class="d-inline-block"
            :placeholder="$t('message.search')"
            @input="searchBarometerSurveyCreated"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-table
          ref="refBarometerSurveyCreatedListTable"
          :items="paginatedBarometerSurveysCreated"
          hover
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty=""
          :empty-text="isLoading ? $t('message.loading') : $t('message.no_records')"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(physical_location)="data">
            {{ data.item.physical_location ? data.item.physical_location : '-' }}
          </template>
          <template #cell(actions)="data">
            <div class="flex flex-column">
              <ViewButton @clicked="openSurvey(data.item.link)"/>

              <b-button
                variant="flat-primary"
                @click="copyLink(data.item.link)"
                class="btn-icon rounded-circle ml-0"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.v-primary.bottom="`${$t('message.copy')}`"
              >
                <feather-icon size="16" icon="CopyIcon" />
              </b-button>

              <b-button
                v-b-modal="`modal ${data.item._id}`"
                variant="flat-primary"
                @click="confirmSendEmail(data.item)"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="btn-icon rounded-circle ml-0"
                v-b-tooltip.hover.v-primary.bottom="`${$t('message.submit')}`"
              >
                <feather-icon size="16" icon="MailIcon"/>
              </b-button>
              
              <b-modal
                :id="`modal ${data.item._id}`"
                centered
                no-close-on-backdrop
                modal-class="modal-primary"
                ok-variant="primary"
                cancel-variant="outline-secondary"
                :title="`${$t('message.sendSurveyToEmployees')} ${mailData.locationName || ''}`"
                :ok-title="$t('message.submit')"
                :cancel-title="$t('message.cancel')"
                @ok="handleSendMail"
                @cancel="showMailModal = false"
              >
                <!-- If there are no employees in the location -->
                <div v-if="(mailData.totalWithEmail || 0) + (mailData.totalWithoutEmail || 0) === 0">
                  <p>{{ $t('message.noEmployeesInLocation') }}</p>
                </div>

                <!-- If there are employees, but none have an email -->
                <div v-else-if="mailData.totalWithEmail === 0">
                  <p>{{ $t('message.employeesWithoutEmail') }}</p>
                </div>

                <!-- If there are employees with an email -->
                <div v-else>
                  <p>
                      {{ $t('message.employeesReceivingSurvey') }} <strong>{{ mailData.totalWithEmail }}</strong>
                  </p>
                  <p v-if="mailData.totalWithoutEmail > 0">
                    {{ $t('message.employeesWithoutEmailCount') }} <strong>{{ mailData.totalWithoutEmail }}</strong>
                  </p>
                </div>
              </b-modal>
              <!-- <EditButton @clicked="router.push({name: 'organization-location-edit', params: { id: data.item._id }})"/> -->
              <!-- <DeleteButton v-b-modal="`modal ${data.item._id}`"/>
              <b-modal
                :id="`modal ${data.item._id}`"
                centered
                no-close-on-backdrop
                modal-class="modal-danger"
                ok-variant="danger"
                cancel-variant="outline-secondary"
                :title="$t('message.confirm_action')"
                :ok-title="$t('message.delete')"
                :cancel-title="$t('message.cancel')"
                @ok="deleteBarometerSurveyCreated(data.item._id)"
              >
                {{ $t('message.confirm_delete_barometer_survey') }}
              </b-modal> -->
            </div>
          </template>
        </b-table>
      </b-col>

      <b-col
        cols="12"
        class="d-flex justify-content-between flex-wrap"
      >
        <div class="mb-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{ $t('message.per_page') }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="perPageOptions"
              class="w-50"
            />
          </b-form-group>
        </div>

        <div class="mb-1">
          <span class="text-muted">{{ showingMessage }}</span>
        </div>

        <b-pagination
          v-model="currentPage"
          :total-rows="totalBarometerSurveysCreated"
          :per-page="perPage"
          first-number=""
          last-number=""
          prev-class="prev-item"
          next-class="next-item"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BPagination, BTable, BModal, VBModal } from 'bootstrap-vue'
import { onMounted, computed } from '@vue/composition-api'
import { useRouter } from '@core/utils/utils'
import ViewButton from '@/views/components/Shared/Buttons/ViewButton.vue'
import EditButton from '@/views/components/Shared/Buttons/EditButton.vue'
import DeleteButton from '@/views/components/Shared/Buttons/DeleteButton.vue'
import useBarometerSurveyCreatedList from './useBarometerSurveyCreatedList'
import Ripple from 'vue-ripple-directive'
import { VBTooltip } from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BPagination,
    ViewButton,
    EditButton,
    DeleteButton,
    BModal,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
  },
  data() {
    return {
      items: [],
    }
  },
  setup() {
    const { router } = useRouter()
    const {
      fetchBarometerSurveysCreated,
      tableColumns,
      perPage,
      currentPage,
      perPageOptions,
      totalBarometerSurveysCreated,
      showingMessage,
      searchQuery,
      sortBy,
      isSortDirDesc,
      barometerSurveysCreated,
      deleteBarometerSurveyCreated,
      isLoading,
      searchBarometerSurveyCreated,
      openSurvey,
      copyLink,
      confirmSendEmail,
      showMailModal,
      handleSendMail,
      getLocationsForDropDown,
      mailData,
      getEmailsWorkers,
    } = useBarometerSurveyCreatedList()

    const paginatedBarometerSurveysCreated = computed(() => {
      const start = (currentPage.value - 1) * perPage.value
      const end = start + perPage.value
      return barometerSurveysCreated.value.slice(start, end)
    })

    onMounted(() => {
      fetchBarometerSurveysCreated()
      getLocationsForDropDown()
      getEmailsWorkers()
    })

    return {
      fetchBarometerSurveysCreated,
      barometerSurveysCreated,
      showingMessage,
      router,
      tableColumns,
      searchQuery,
      sortBy,
      isSortDirDesc,
      deleteBarometerSurveyCreated,
      totalBarometerSurveysCreated,
      currentPage,
      perPageOptions,
      perPage,
      isLoading,
      searchBarometerSurveyCreated,
      paginatedBarometerSurveysCreated,
      openSurvey,
      copyLink,
      confirmSendEmail,
      showMailModal,
      handleSendMail,
      getLocationsForDropDown,
      mailData,
      getEmailsWorkers,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.process-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

.form-group {
  label {
    font-size: 0.85rem;
    font-weight: 400;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
